import { createClient } from '@blinkdotnew/sdk'

// Initialize Blink SDK with proper configuration
export const blink = createClient({
  projectId: 'lemon-ui-agentic-email-ai-agent-ben3ou87',
  authRequired: false, // Allow app to load without auth - let components handle auth checks
  auth: {
    mode: 'headless' // Use headless mode for custom login UI with full control
  }
})

// Disable Blink analytics to prevent network errors during development
if (blink.analytics?.isEnabled()) {
  blink.analytics.disable();
}

// Debug logging for authentication state
console.log('🚀 Blink SDK initialized with headless auth mode (auth not required)');
console.log('🔧 SDK config:', {
  projectId: 'lemon-ui-agentic-email-ai-agent-ben3ou87',
  authMode: 'headless',
  authRequired: false
});
